import { datadogRum } from '@datadog/browser-rum';

import type { Environment } from 'src/types';
import { isEnvProd } from 'src/utils/isEnvironment';

//  https://app.datadoghq.com/rum/application/35e6f3ef-8b84-4d2a-860f-993e2bb5e894/overview/browser?from_ts=1683788196543&to_ts=1683874596543&live=true
export const initDatadogRUM = (
  environment: Environment,
  buildVersion: string,
  branch: string,
  context: Record<string, unknown>,
) => {
  const shouldEnableDataDogRUM = isEnvProd(environment) && branch === 'master';

  datadogRum.init({
    applicationId: '35e6f3ef-8b84-4d2a-860f-993e2bb5e894',
    clientToken: 'pub163324883a84a6fdc7483cf43f1f88da',
    site: 'datadoghq.com',
    service: 'hirer-invoices-ui',
    version: `${buildVersion}-country-${context['user-country']}`,
    env: environment,
    sessionReplaySampleRate: 0,
    defaultPrivacyLevel: 'mask-user-input',
    sessionSampleRate: shouldEnableDataDogRUM ? 100 : 0,
    trackUserInteractions: true,
    silentMultipleInit: true,
  });

  datadogRum.setGlobalContext(context);
};

export const isDataDogRUMEnabled = () =>
  datadogRum &&
  Number(datadogRum.getInitConfiguration()?.sessionSampleRate) > 0;
